module.exports = __webpack_public_path__ + "static/media/patrol.11b4c242.jpg";